import gql from 'graphql-tag';

const expireGuaranteePurchaseMutation = gql`
  mutation expireGuaranteePurchase(
    $expireInput: ExpireGuaranteePurchaseInput!
  ) {
    expireGuaranteePurchase(input: $expireInput) {
      success
      errors
    }
  }
`;

export default expireGuaranteePurchaseMutation;
